import { render } from "./CoinRecharge.vue?vue&type=template&id=5726d933&scoped=true"
import script from "./CoinRecharge.vue?vue&type=script&lang=js"
export * from "./CoinRecharge.vue?vue&type=script&lang=js"

import "./CoinRecharge.vue?vue&type=style&index=0&id=5726d933&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5726d933"]])

export default __exports__